<template>
  <div>
    <b-nav-item-dropdown right no-caret class="d-md-down-none" style="min-width: 200px">
      <template slot="button-content">
        <img src="static/img/avatars/9.jpg" class="img-avatar" alt="admin@bootstrapmaster.com" />
        <em>{{ fullName }}</em>
      </template>
      <b-dropdown-header tag="div" class="text-center">
        <strong> {{ uniTranslation("PHEaccount") }} </strong>
      </b-dropdown-header>
      <span v-if="isAdmin || isUnilab">
        <b-dropdown-item @click="showTranslationsIdToggle"
          ><i class="fa fa-wrench"></i> Show Translations ID</b-dropdown-item
        >
        <b-dropdown-item @click="showEnglishToolTip"
          ><i class="fa fa-wrench"></i> Show English ToolTip</b-dropdown-item
        >
      </span>
      <b-dropdown-item @click="showPrivacyAndCompliance"
        ><i class="fa fa-warning"></i>{{ uniTranslation("PHEprivacy") }}</b-dropdown-item
      >
      <b-dropdown-item @click="showUserData">
        <i class="fa fa-user"></i>{{ uniTranslation("USERDATA") }}</b-dropdown-item
      >
      <!--<b-dropdown-item><i class="fa fa-user"></i> Profile</b-dropdown-item>-->
      <b-dropdown-item @click="onClickLogout"
        ><i class="fa fa-lock"></i> {{ uniTranslation("PHElogout") }}</b-dropdown-item
      >
    </b-nav-item-dropdown>

    <b-modal
      v-model="bShowUserData"
      hide-header
      no-close-on-backdrop
      :ok-title="uniTranslation('OK')"
      :cancel-title="uniTranslation('CANCEL')"
      @ok="saveUserData"
      @cancel="resetUserData"
    >
      <label for="printEmail">{{ uniTranslation("EMAIL") }}</label>
      <b-form-input id="printEmail" v-model="email" type="text" required />
      <br />
      <label for="printPNumber">{{ uniTranslation("TELNUM") }}</label>
      <b-form-input id="printPNumber" v-model="pNumber" type="text" required />
    </b-modal>
  </div>
</template>

<script>
import store from "../../store";
import Cookies from "js-cookie";
import generalService from "../../services/backendCipriani/generalService";

export default {
  name: "HeaderDropdown",
  data() {
    return {
      itemsCount: 42,
      fullName: "",
      bShowUserData: false,
      email: "",
      pNumber: ""
    };
  },
  computed: {
    isAdmin: function() {
      return this.$store.getters.isLoggedUserAdmin;
    },
    isUnilab: function() {
      return this.$store.getters.isLoggedUserUnilab;
    }
  },
  mounted: function() {
    var that = this;
    that.fullName = that.$store.getters.loggedUserInfo.fullName;

    this.resetUserData();

    if (that.fullName == null) {
      this.onClickLogout();
    }
    if (that.fullName == "") {
      this.onClickLogout();
    }
  },

  methods: {
    showTranslationsIdToggle(e) {
      e.preventDefault();
      store.dispatch("bShowTranslationsId");
    },
    showEnglishToolTip(e) {
      e.preventDefault();
      store.dispatch("bShowEnglishToolTip");
    },
    showPrivacyAndCompliance() {
      this.$router.push("/privacy");
    },

    onClickLogout() {
      // unsaved offerta attiva
      this.$store.commit("resetOffertaAttiva");

      // alert(this.$store.getters.getIdOffertaAttiva);

      Cookies.remove("loginToken");

      // reload page
      this.$router.go();
    },

    showUserData() {
      this.bShowUserData = true;
    },

    resetUserData() {
      var that = this;
      that.email = that.$store.getters.loggedUserInfo.userMail;
      that.pNumber = that.$store.getters.loggedUserInfo.userTel;
    },

    saveUserData() {
      var that = this;
      var datiUtente = {
        email: this.email,
        pNumber: this.pNumber
      };
      generalService
        .setDatiUtente(datiUtente)
        .then(function(data) {
          if (data) {
            that.$store.getters.loggedUserInfo.userMail = that.email;
            that.$store.getters.loggedUserInfo.userTel = that.pNumber;
          } else {
            that.resetUserData();
          }
        })
        .catch(() => {
          that.resetUserData();
        });
    }
  }
};
</script>
